import textStyles from "../../../../theme/foundations/generated/textStyles";
function getVariantsFromTextStyles(textStylesList) {
    return Object.entries(textStylesList).reduce((acc, [currentPartName, currentPart]) => {
        const currentPartSubParts = Object.entries(currentPart).reduce((accCurrentPart, [subPartName, currentSubPart]) => (Object.assign(Object.assign({}, accCurrentPart), { [`${currentPartName}.${subPartName}`]: currentSubPart })), {});
        return Object.assign(Object.assign({}, acc), currentPartSubParts);
    }, {});
}
const ComponentStyle = {
    variants: getVariantsFromTextStyles(textStyles),
    defaultProps: {
        variant: "body.medium",
    },
};
export default ComponentStyle;
//# sourceMappingURL=Text.default.js.map